"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React, { useRef } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperInstance } from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { FaChevronLeft, FaChevronRight, FaStar, FaQuoteLeft } from "react-icons/fa";
import { shopifyClientStories, ShopifyClientStory } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyClientStoriesProps {
  eyebrow?: string;
  heading?: string;
  subtitle?: string;
  stories?: ShopifyClientStory[];
  className?: string;
}
export default function ShopifyClientStories(t0) {
  const $ = _c(40);
  const {
    eyebrow: t1,
    heading: t2,
    subtitle: t3,
    stories: t4,
    className: t5
  } = t0;
  const eyebrow = t1 === undefined ? "REVIEWS" : t1;
  const heading = t2 === undefined ? "About Client Story" : t2;
  const subtitle = t3 === undefined ? "Check our customers success stories." : t3;
  const stories = t4 === undefined ? shopifyClientStories : t4;
  const className = t5 === undefined ? "" : t5;
  const desktopAnimations = useDesktopAnimations();
  const swiperRef = useRef(null);
  const t6 = `relative overflow-hidden bg-[#fdf0f0] py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#0c101c] ${className}`;
  let t7;
  if ($[0] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false;
    $[0] = desktopAnimations;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== desktopAnimations) {
    t8 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== desktopAnimations) {
    t9 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  let t11;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      once: true
    };
    t11 = {
      duration: 0.7,
      ease
    };
    $[6] = t10;
    $[7] = t11;
  } else {
    t10 = $[6];
    t11 = $[7];
  }
  let t12;
  if ($[8] !== eyebrow) {
    t12 = eyebrow && <p className="font-poppins mb-2 text-[13px] font-semibold tracking-wider text-[#f6248c] uppercase sm:text-[14px]">{eyebrow}</p>;
    $[8] = eyebrow;
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  let t13;
  if ($[10] !== heading) {
    t13 = <h2 className="font-poppins text-[30px] font-bold leading-tight text-[#0b1354] sm:text-[38px] lg:text-[44px] dark:text-white">{heading}</h2>;
    $[10] = heading;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== subtitle) {
    t14 = subtitle && <p className="font-sans mt-2.5 text-[14px] font-normal text-[#66698a] sm:text-[16px] dark:text-gray-400">{subtitle}</p>;
    $[12] = subtitle;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t12 || $[15] !== t13 || $[16] !== t14 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t15 = <motion.div initial={t7} whileInView={t8} animate={t9} viewport={t10} transition={t11} className="mb-12 text-center md:mb-16">{t12}{t13}{t14}</motion.div>;
    $[14] = t12;
    $[15] = t13;
    $[16] = t14;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => swiperRef.current?.slidePrev();
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <button type="button" onClick={t16} aria-label="Previous review" className="absolute -left-1 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-[#f6248c] text-white shadow-[0_6px_20px_rgba(246,36,140,0.4)] transition-all duration-200  active:scale-95 sm:-left-3 sm:h-12 sm:w-12 lg:-left-5"><FaChevronLeft className="-ml-0.5 text-sm sm:text-base" /></button>;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = () => swiperRef.current?.slideNext();
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <button type="button" onClick={t18} aria-label="Next review" className="absolute -right-1 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-[#f6248c] text-white shadow-[0_6px_20px_rgba(246,36,140,0.4)] transition-all duration-200  active:scale-95 sm:-right-3 sm:h-12 sm:w-12 lg:-right-5"><FaChevronRight className="-mr-0.5 text-sm sm:text-base" /></button>;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = [Autoplay];
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  const t21 = stories.length > 3;
  let t22;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    };
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  let t23;
  let t24;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = swiper => {
      swiperRef.current = swiper;
    };
    t24 = {
      640: {
        slidesPerView: 2,
        spaceBetween: 22
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 26
      }
    };
    $[27] = t23;
    $[28] = t24;
  } else {
    t23 = $[27];
    t24 = $[28];
  }
  let t25;
  if ($[29] !== stories) {
    t25 = stories.map(_temp);
    $[29] = stories;
    $[30] = t25;
  } else {
    t25 = $[30];
  }
  let t26;
  if ($[31] !== t21 || $[32] !== t25) {
    t26 = <div className="relative px-2 sm:px-6 lg:px-8">{t17}{t19}<Swiper modules={t20} loop={t21} autoplay={t22} spaceBetween={20} slidesPerView={1} onBeforeInit={t23} breakpoints={t24} className="w-full pb-4 [&_.swiper-wrapper]:items-stretch">{t25}</Swiper></div>;
    $[31] = t21;
    $[32] = t25;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t15 || $[35] !== t26) {
    t27 = <div className="relative z-10 mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">{t15}{t26}</div>;
    $[34] = t15;
    $[35] = t26;
    $[36] = t27;
  } else {
    t27 = $[36];
  }
  let t28;
  if ($[37] !== t27 || $[38] !== t6) {
    t28 = <section className={t6}>{t27}</section>;
    $[37] = t27;
    $[38] = t6;
    $[39] = t28;
  } else {
    t28 = $[39];
  }
  return t28;
}
function _temp(story) {
  return <SwiperSlide key={story.id} className="!h-auto"><article className="group flex h-full flex-col justify-between rounded-[20px] border border-gray-100/90 bg-white p-6 shadow-[0_8px_30px_rgba(20,50,90,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(20,50,90,0.1)] sm:p-7 dark:border-gray-800 dark:bg-gray-900"><div className="flex items-center justify-between gap-4"><FaQuoteLeft className="text-[28px] text-[#3c4a85] sm:text-[32px] dark:text-indigo-400" />{story.brandLogo && <Image src={story.brandLogo} alt={story.brandAlt ?? `${story.name} logo`} width={120} height={32} loading="lazy" className="h-7 w-auto max-w-[120px] object-contain sm:h-8" />}</div><p className="font-sans my-5 flex-1 text-[14px] leading-[25px] text-[#5e6282] sm:text-[14.5px] dark:text-gray-300">{story.review}</p><div className="flex items-center gap-3.5 pt-2">{story.avatar ? <Image src={story.avatar} alt={story.name} width={48} height={48} loading="lazy" className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-pink-100 dark:ring-gray-800" /> : <span aria-hidden={true} className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#f4e7ef] font-poppins text-[18px] font-bold text-[#0b1354] ring-2 ring-pink-100 dark:bg-gray-800 dark:text-white dark:ring-gray-800">{story.name.trim().charAt(0).toUpperCase()}</span>}<div className="min-w-0 flex-1"><h3 className="font-poppins truncate text-[15px] font-bold text-[#0b1354] dark:text-white">{story.name}</h3>{(story.role || story.location) && <p className="font-sans truncate text-[12.5px] text-[#8e92a4] dark:text-gray-400">{[story.role, story.location].filter(Boolean).join(", ")}</p>}<div className="mt-1 flex items-center gap-1 text-[13px]">{[1, 2, 3, 4, 5].map(star => <FaStar key={star} className={star <= story.rating ? "text-[#f97316]" : "text-[#cbd5e1] dark:text-gray-700"} />)}</div></div></div></article></SwiperSlide>;
}